import { memo } from "react";
import { ConfigProvider, Layout as AntLayout } from "antd";
import Layout from "@components/wrappers/layouts/main-layout/Layout";
import {
    DEFAULT_DASHBOARD_THEME,
} from "@ts/constants";
import { theme } from "antd";
import CreateCampaignContext from "./CreateCampaignContext";
import CampaignCreationContent from "./CampaignCreationContent";
import "@/scss/campaign-creation.scss";

const CampaignCreation: React.FC = memo(() => {
    return (
        <CreateCampaignContext>
            <Layout>
                <ConfigProvider
                    theme={{
                        ...DEFAULT_DASHBOARD_THEME,
                        algorithm: theme.defaultAlgorithm,
                        components: {
                            ...DEFAULT_DASHBOARD_THEME.components,
                            Layout: {
                                bodyBg: "#f8f9fa",
                                headerBg: "#ffffff",
                                headerHeight: 64,
                                headerPadding: "0 24px",
                            },
                            Card: {
                                borderRadiusLG: 8,
                            },
                        },
                    }}
                >
                    <AntLayout>
                        <AntLayout.Content
                            style={{
                                backgroundColor: "#f8f9fa",
                                padding: "24px",
                                height: "calc(100vh - 120px)",
                                overflow: "hidden",
                            }}
                        >
                            <CampaignCreationContent />
                        </AntLayout.Content>
                    </AntLayout>
                </ConfigProvider>
            </Layout>
        </CreateCampaignContext>
    );
});

export default memo(CampaignCreation);